import React from 'react';

export enum ButtonType {
  button = 'button',
  text = 'text',
  /** Transparent, button-shaped (padded) with a colored label and a subtle hover fill. */
  ghost = 'ghost',
}

export enum ButtonSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export enum ButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
  danger = 'danger',
  warn = 'warn',
}

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonType?: ButtonType;
  size?: ButtonSize;
  variant?: ButtonVariant;
  isLoading?: boolean;
  children?: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
